import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import cx from 'classnames';
import querystring from 'querystring';
import { uploadFile } from '@appcraft/form-sdk/http';
import { iconForFilename, sizeLabel } from './utils';
import { Error } from '../fields/errors';
import InputBlocker from './InputBlocker';
import i18n from '../translations';
import './FileUploader.scss';


function uploadAssetFile(file, options) {
  let url = window.__DATA__.api.file;
  if (options) {
    url += '?' + querystring.stringify(options);
  }

  return uploadFile(url, file);
}

const File = ({ originalFilename, size }) => {
  return (
    <div className="af-file-dropzone__file">
      <i className={`fa fa-${iconForFilename(originalFilename)}`} style={{ marginRight: 5 }} />
      {originalFilename}
      <br />
      {sizeLabel(size)}
    </div>
  );
};

export default class FileUploader extends Component {
  state = {
    uploading: false,
    state: 'adding',
  };

  handleDrop = async (accepted, rejected) => {
    const { privacyMode } = this.props;

    if (accepted.length > 0) {
      this.setState({ state: 'uploading' });
      try {
        const res = await uploadAssetFile(accepted[0], { mode: privacyMode });
        if (res.errors) {
          this.setState({ state: 'error' });
          return;
        }
        const json = { ...res, url: res.uri };

        const { onChange, field } = this.props;
        if (onChange) {
          this.setState({ state: 'added' });
          onChange(field, json);
        }
      } catch (e) {
        this.setState({ state: 'adding' });
        console.log(e);
      }
    } else {
      console.log('No file to upload !');
    }
  };

  handleRemove = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { onChange, field } = this.props;
    if (onChange) {
      onChange(field, null);
      this.setState({ state: 'adding' });
    }
  };

  render() {
    const { state } = this.state;
    const { value, placeholder = i18n.t('file.upload.drop-file'), acceptedFiles, required, disabled, strings = {} } = this.props;
    const { invalidMsg = i18n.t('file.upload.invalid-file') } = strings;

    if (value && (value.uri || value.id)) {
      return (
        <div
          className={cx('af-file-dropzone', 'af-file-dropzone--filled', disabled && 'af-file-dropzone--disabled')}
        >
          {!disabled && <i className="fa fa-times af-file-dropzone__remove" onClick={this.handleRemove} />}
          <File {...value} />
        </div>
      );
    }
    return (
      <>
        <Dropzone
          className={cx('af-file-dropzone', disabled && 'af-file-dropzone--disabled', state === 'error' && 'af-file-dropzone--error')}
          activeClassName="af-file-dropzone--active"
          rejectClassName="af-file-dropzone--rejected"
          accept={!!acceptedFiles ? acceptedFiles : undefined}
          onDrop={this.handleDrop}
          inputProps={{ required, disabled }}
        >
          {state === 'adding' && <div>{placeholder}</div>}
          {state === 'uploading' && <div>Loading...</div>}
          {state === 'error' && (
            <div>
              <Error message={invalidMsg} />

              <i className="fa fa-times af-file-dropzone__remove" onClick={this.handleRemove} />

              <InputBlocker name="fileUpload" style={{ width: '100%' }} />
            </div>
          )}
        </Dropzone>
      </>
    );
  }
}
